import { lazy } from "react";
export var LazySignUpRootWithLazyRoutes = /*#__PURE__*/ lazy(function() {
    return import(/* webpackChunkName: "retailer-sign-up-lazy-routes" */ "@faire/retailer-visitor-shared/views/SignUp/_lazy-route-wrappers/SignUpRootWithLazyRoutes").then(function(m) {
        return {
            default: m.SignUpRootWithLazyRoutes
        };
    });
});
